<template>
  <div class="container mycontainer">
    <h1 class="style-h3">
      Formations professionnelles spécialisées à distance ou en présentiel
    </h1>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <div class="card card-formation" style="padding: 5px">
          <div class="row">
            <div class="col-12">
              <div class="section-title text-center">
                <p>
                  Créez une alerte pour être informé des prochaines dates de
                  formation qui vous intéresse. <br />Sélectionner la ou les
                  spécialités, renseignez votre adresse email et validez.
                </p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 centered">
              <multiselect
                placeholder="Selectionner une ou plusieurs specialité(s)"
                v-model="valuesList"
                :multiple="true"
                :taggable="true"
                :options="options2Alert"
                label="text"
              ></multiselect>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6">
              <input
                style="margin-left: 1vh; width: 90%; margin-top: 1vh"
                type="email"
                v-model="emailAlert"
                name="email"
                placeholder="votre@email.com"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6">
              <b-button
                squared
                block
                variant="dark"
                :disabled="isDisabled"
                v-on:click="sendAlert"
                ><b-icon-bell-fill></b-icon-bell-fill> Alertez moi quand une
                date est disponible</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <form action="" class="form-inline">
      <div class="form-group" hidden>
        <select
          class="form-control"
          id="mySelect"
          @change="filtrer($event)"
          v-model="selected_public"
        >
          <option v-for="option in options" v-bind:value="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>
      <div class="form-group ml-4" style="margin-left: 10px !important">
        <select
          class="form-control"
          v-model="selected_secteur"
          id="mySelect2"
          @change="filtrer($event)"
        >
          <option v-for="option in options2" v-bind:value="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>
    </form>
    <div class="row">
      <div
        class="col-12 col-sm-6 col-md-4 col-lg-4"
        v-for="item in tmp_data"
        :key="item.id"
      >
        <div class="card card-formation" style="min-height:850px;">
          <h4 class="card-title" style="height:100px;">{{ item.nomFormation }}</h4>
          <div class="card-img text-center">
            <img
              :src="item.image"
              alt=""
              style="
                max-width: 100%;
                max-height: 100%;
                height: auto;
                width: auto;
              "
            />
          </div>
          <div class="card-body">
            <p>
              <strong>Date</strong> :{{ returnDate(item.dateFormation) }}
              <!--{{ new Date(item.dateFormation).toLocaleDateString("fr-FR") }}-->
              <br />
              <strong>Public</strong> : {{ item.publicFormation }} <br />
              <strong>Objectifs</strong> : {{ item.objectifFormation }} <br />
              <strong>Durée</strong> : {{ item.dureeFormation }} <br />
              <strong>Format</strong> : {{ item.formatFormation }} <br />
              <strong>Formateur</strong> : {{ item.formateur }} <br />
              <strong>Numéro de formation</strong> : {{ item.idformation }}
              <br />
            </p>
            <a
              class="btn btn-success btn-block"
              data-toggle="modal"
              :data-target="'#exampleModal' + item.id"
              >Détails de la formation</a
            >
            <a
              class="btn btn-primary btn-block"
              v-on:click="inscripion(item.id)"
              >Participer</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        v-for="item in tmp_data"
        :key="item.id"
        class="modal fade"
        :id="'exampleModal' + item.id"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title" id="exampleModalLabel">
                Formation {{ item.nomFormation }}
              </h3>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="d-flex align-items-start">
                <div class="modal-body-avatar">
                  <img :src="item.image" alt="" />
                </div>

                <div
                  class="modal-body-content"
                  style="
                    max-height: calc(100vh - 210px);
                    overflow-y: auto !important;
                    width: 100%;
                  "
                >
                  <h4 style="color: rgb(47, 49, 53) !important">
                    Récapitulatif:
                  </h4>
                  <p style="margin-left: 1vh">
                    <strong>Date</strong> : {{ returnDate(item.dateFormation) }}
                    <!--{{ item.dateFormation }}-->
                    <br />
                    <strong>Public</strong> : {{ item.publicFormation }} <br />
                    <strong>Objectifs</strong> : {{ item.objectifFormation }}
                    <br />
                    <strong>Durée</strong> : {{ item.dureeFormation }} <br />
                    <strong>Format</strong> : {{ item.formatFormation }} <br />
                    <strong>Formateur</strong> : {{ item.formateur }} <br />
                  </p>
                  <hr />
                  <h4 style="color: rgb(47, 49, 53) !important">
                    Détails de la formation:
                  </h4>
                  <div v-html="item.details" style="margin-left: 1vh"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="my-modal" class="my-modal" hide-footer title="Informations">
      Connectez-vous à Oforis avant de pouvoir vous inscrire
    </b-modal>
    <b-modal id="my-modal2" class="my-modal" hide-footer title="Informations">
      Vous êtes déjà inscrit à cette formation
    </b-modal>
    <b-modal id="my-modal3" class="my-modal" hide-footer title="Informations">
      Bravo! Vous êtes inscrit à cette formation. Elle est désormée présente
      dans votre profil/mes formations.
    </b-modal>
  </div>
</template>
<script>
import firebase from "../main";
import Multiselect from "vue-multiselect";
import emailjs from "emailjs-com";
export default {
  components: {
    Multiselect,
  },
  metaInfo() {
    return {
      title: "Toutes les formations OFORIS",
      meta: [
        {
          name: "description",
          content:
            "Trouvez votre formation médicale spécialisée OFORIS en Ophtalmologie, Hypnose, Cardiologie, Anesthésie, Médecine d’Urgence",
        },
        {
          name: "keywords",
          content:
            "Développement professionnel,Formation ophtalmologie pour secrétaires,Formation cardiologie ,Formation anesthésie ,Formation urgences ,Orthopstie",
        },
        {
          property: "og:title",
          content: "Toutes les formations OFORIS",
        },
        { property: "og:site_name", content: "Oforis" },
        { property: "og:type", content: "website" },
      ],
    };
  },
  mounted: function () {},
  created: function () {
    this.$firestore
      .collection("formateurs")
      .get()
      .then((snapshot) => {
        this.formateursF = {};
        snapshot.forEach((doc) => {
          this.formateursF[doc.id] =
            doc.data()["nom"] + " " + doc.data()["prenom"];
        });
      })
      .catch((err) => {
        console.log("Error getting documents", err);
      });
    this.$firestore
      .collection("formations")
      .orderBy("dateFormation", "asc")
      .get()
      .then((snapshot) => {
        this.data = [];
        snapshot.forEach(
          (doc) => {
            let k = doc.data();
            k["id"] = doc.id;
            //console.log(k["dateFormation"]);
            var fdate = k["dateFormation"];
            if (fdate == "") {
              fdate = Date.now();
            } else {
              fdate = Date.parse(k["dateFormation"]);
            }
            var d2 = Date.now();
            k["formateur"] = this.formateursF[k["idFormationFormateur"]];
            if (fdate >= d2) {
              this.data.push(k);
              this.list_public.push(k["publicFormation"]);
              this.list_secteur.push(k["specialiteFormation"]);
            }
          } /*console.log(this.data)*/
        );
        this.tmp_data = this.data;
        this.list_secteur = [...new Set(this.list_secteur)];
        this.list_public = [...new Set(this.list_public)];
        this.options = [];
        var _options = [{ value: null, text: "Tout public" }];
        this.list_public.forEach(function (val) {
          _options.push({ value: val, text: val });
        });
        this.options = _options;

        this.options2 = [];
        var _options2 = [{ value: null, text: "Tout secteur" }];
        this.list_secteur.forEach(function (val) {
          _options2.push({ value: val, text: val });
        });
        this.options2 = _options2;
        this.options2.forEach((value, index) => {
          if (index > 0) {
            this.options2Alert.push(value);
          }
        });
      })
      .catch((err) => {
        console.log("Error getting documents", err);
      });
  },
  data() {
    return {
      valuesList: [],
      emailAlert: "",
      publicPath: process.env.BASE_URL,
      utilisateur: firebase.auth().currentUser,
      selected_public: null,
      selected_secteur: null,
      options: [],
      options2: [],
      options2Alert: [],
      tmp_data: [],
      data: [],
      list_public: [],
      list_secteur: [],
      formateursF: [],
    };
  },
  methods: {
    sendEmail: function (e) {
      emailjs
        .send(
          "service_va5a6po",
          "template_q08cd0f",
          e,
          "user_B4hWS58lLswMquAYoUKQG"
        )
        .then(
          (result) => {
            console.log("SUCCESS!", result.status, result.text);
            this.$notify({
              group: "foo",
              title: "Information",
              text: "Votre alerte a été créée",
              duration: 1000,
              speed: 1000,
            });
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );
    },
    sendAlert() {
      //this.sendEmail(templateParams);
      var formations = "<ul>";
      this.valuesList.forEach((value, index) => {
        formations += "<li>" + value.value + "</li>";
      });
      formations += "</ul>";
      var templateParams = {
        email: this.emailAlert,
        formation: formations,
      };

      this.sendEmail(templateParams);
      this.valuesList = [];
      this.emailAlert = "";
    },
    returnDate(elem) {
      if (elem != "") return new Date(elem).toLocaleDateString("fr-FR");
      else return "Pas de date fixée";
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName("formations")[0];

      if (el) {
        el.scrollIntoView();
      }
    },
    showModal2() {
      this.$bvModal.show("my-modal2");
    },
    showModal3() {
      this.$bvModal.show("my-modal3");
    },
    inscripion: function (id) {
      if (firebase.auth().currentUser) {
        this.$firestore
          .collection("formations")
          .doc(id)
          .get()
          .then((snapshot) => {
            var infos = snapshot.data();
            var docRef = this.$firestore.collection("inscriptions").doc(id);
            docRef
              .get()
              .then((doc) => {
                if (doc.exists) {
                  if (
                    doc
                      .data()
                      ["inscrits"].includes(firebase.auth().currentUser.uid)
                  ) {
                    this.$bvModal.show("my-modal2");
                  } else {
                    docRef.update({
                      inscrits: firebase.firestore.FieldValue.arrayUnion(
                        firebase.auth().currentUser.uid
                      ),
                    });
                    this.$bvModal.show("my-modal3");
                  }
                } else {
                  // doc.data() will be undefined in this case
                  docRef.set({
                    inscrits: [firebase.auth().currentUser.uid],
                  });
                }
              })
              .catch(function (error) {
                console.log("Error getting document:", error);
              });
          });
      } else {
        this.$bvModal.show("my-modal");
      }
    },
    filtrer: function () {
      var tmp_data = [];
      if (this.selected_secteur == null) {
        tmp_data = this.data;
      } else {
        var selected_secteur = this.selected_secteur;
        if (this.selected_secteur != null) {
          this.data.map(function (value, key) {
            if (value.specialiteFormation == selected_secteur) {
              if (!tmp_data.some((person) => person.id === value.id)) {
                tmp_data.push(value);
              }
            }
          });
        }
      }
      this.tmp_data = tmp_data;
      //console.log(this.tmp_data);
    },
  },
  computed: {
    isDisabled: function () {
      return (
        !/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.emailAlert
        ) || this.valuesList.length == 0
      );
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scss>
body.is-home {
  background-image: None !important;
  background-size: 60%;
}

</style>